import { default as i18next, type InitOptions } from "i18next";

export interface Binding {
    el: HTMLElement;
    key: string;
    defaultText: string;
    params: { [key: string] : string; } | null;
};

export interface LanguageOptions {
    lang: string;
}

export interface ResourceBundle {
    lang: string;
    namespace: string;
    resources: any;
}

const defaultOptions: LanguageOptions = {
	lang: 'en'
};

export default class Language {
    private options: LanguageOptions;
    private bindings: Array<Binding>;

	constructor(options: LanguageOptions) {
		const _this = this;
		this.options = Object.assign(defaultOptions, options);

		let lang: string = this.options.lang;

		if(!lang || lang == '') {
			lang = document.querySelector('html')?.getAttribute('lang') as string;
			if(lang) {
				if(lang.indexOf('-') > -1) {
					lang = lang.substr(0, lang.indexOf('-'));
				}
			} else {
                lang = 'en';
            }
		}

        try {
            const initOptions: InitOptions = {
                lng: lang,
                fallbackLng: 'en',
                defaultNS: 'common'
            };
            i18next.init(initOptions);
            if((window as any).TYPO3.lang) {
                const bundle: ResourceBundle = {
                    lang: lang,
                    namespace: 'common',
                    resources: (window as any).TYPO3.lang
                }
                _this.addResourceBundle(bundle);
            }

            i18next.changeLanguage(lang);
        } catch (e) {

        }
	}

    public addBundles(bundles: ResourceBundle[] | ResourceBundle) {
        if(!Array.isArray(bundles)) {
            bundles = [ bundles ];
        }
        this.addResourceBundles(bundles);
    }

	public addResourceBundles(bundles: ResourceBundle[]) {
        const self = this;
        if(Array.isArray(bundles)) {
            bundles.forEach((bundle: ResourceBundle) => {
                self.addResourceBundle(bundle);
            });
        }
	}

    public addResourceBundle(bundle: ResourceBundle) {
        if(typeof(bundle.lang) == 'undefined') {
            bundle.lang = i18next.language;
        }

        i18next.addResourceBundle(bundle.lang, bundle.namespace, bundle.resources, true, true);
	}

	public setCurrentLanguage(lang: string) {
        i18next.changeLanguage(lang);
	}

	public getCurrentLanguage(): string {
		return i18next.language;
	}

	public translate(key: string, params: { [key: string] : string; } | null = null, defaultText: string = '', namespace: string = 'common'): string {
		let translated: string = i18next.t(key, { ns: namespace });
		if(translated == key && defaultText && defaultText != '') {
			translated = defaultText;
		}
        if(params) {
            for(const k in params) {
                const regExp = new RegExp('\{\{'+k+'\}\}', 'ig');
                translated = translated.replace(regExp, params[k]);
            }
        }
        return translated;
	}

	public t(key: string, params: { [key: string] : string; } | null = null, defaultText: string = '', namespace: string = 'common'): string {
		return this.translate(key, params, defaultText);
	}

	public translateBounded(key: string, params: { [key: string] : string; } | null = null, defaultText: string = '', namespace: string = 'common') {
		const el = document.createElement('span');
		this.bindings.push({
			el: el,
			key: key,
			defaultText: defaultText,
			params: params
		});
		return el;
	}

	public tb(key: string, params: { [key: string] : string; } | null = null, defaultText: string = '') {
		return this.translateBounded(key, params, defaultText);
	}
}

